import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            热门赛道
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            每日大赛热门创作赛道，选择你感兴趣的话题参与创作竞技
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {carouselItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/50 transition-colors cursor-pointer group"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={idx > 3 ? 'lazy' : undefined}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold rounded-full bg-primary-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
                    {item.desc}
                  </p>
                  <span className="text-xs text-primary-600 font-medium">
                    {item.stat}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}